/**
 * Treatments Thunks
 * Async actions for treatment operations
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCurrentDateTreatment } from '../api/treatmentsApi';

/**
 * Fetch current date treatment for a patient
 */
export const fetchPatientTreatment = createAsyncThunk(
  'emr/fetchPatientTreatment',
  async ({ customerId, date }, { rejectWithValue }) => {
    try {
      const data = await fetchCurrentDateTreatment(customerId, date);
      return {
        customerId,
        date,
        treatments: data.treatments || [],
        totalCount: data.totalCount || 0,
        latestTreatment: data.treatments?.[data.treatments.length - 1] || null
      };
    } catch (error) {
      console.error('Error fetching patient treatment:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
